import { defineStore } from 'pinia';
import { ref } from 'vue';
import contactsAPI from '@/api/contacts';
import type { Contact } from '@/types/Contact';

export const useContactsStore = defineStore('contacts', () => {
  const contacts = ref<Contact[]>([]);
  const contacts_result = ref<Contact[]>([]);
  
  const fetchContacts = async (params: any): Promise<{ data: Contact[]; total: number }> => {
    try {
      const response = await contactsAPI.getContacts(params);
      const data: Contact[] = response.data.data;
      const total = response.data.meta.total;
      contacts.value = data;
      return { data, total };
    } catch (error) {
      console.error('Error fetching contacts:', error);
      throw error;
    }
  };

  const fetchContactById = async (id: number) => {
    try {
      const response = await contactsAPI.getContactById(id);
      return response.data.data as Contact;
    } catch (error) {
      console.error(`Error fetching contact  with ID ${id}:`, error);
      throw error;
    }
  };

  const createContact = async (contactData: Partial<Contact>) => {
    try {
      const response = await contactsAPI.createContact(contactData);
      if (!response.data.success) {
        throw response.data;
      }
      contacts.value.push(response.data.data as Contact);
      return response.data;
    } catch (error) {
      console.error('Error creating contact:', error);
      throw error;
    }
  };

  const updateContact = async (id: number, contactData: Partial<Contact>) => {
    try {
      const response = await contactsAPI.updateContact(id, contactData);
      if (!response.data.success) {
        throw response.data;
      }
      const updated = response.data.data as Contact;
      const index = contacts.value.findIndex((c:any) => c.id === id);
      if (index !== -1) {
        contacts.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating contact with ID ${id}:`, error);
      throw error;
    }
  };

  const deleteContact = async (id: number) => {
    try {
      await contactsAPI.deleteContact(id);
      contacts.value = contacts.value.filter((c) => c.id !== id);
    } catch (error) {
      console.error(`Error deleting contact with ID ${id}:`, error);
      throw error;
    }
  };

  const fetchContactByClientId = async (id: number) => {
    try {
      const response = await contactsAPI.getContactByClientId(id);
      const data: Contact[] = response.data.data;
      const total = response.data.meta.total;
      contacts.value = data;
      return { data, total };
    } catch (error) {
      console.error(`Error fetching contact with ID ${id}:`, error);
      throw error;
    }
  };

  const searchContact = async (params: any): Promise<{ data: Contact[]}> => {
    try {
      const response = await contactsAPI.searchContact(params);
      const data: Contact[] = response.data.data;
      contacts_result.value = data
      return { data };
    } catch (error) {
      console.error('Error fetching contacts:', error);
      throw error;
    }
  };

  return {
    contacts,
    contacts_result,
    fetchContacts,
    fetchContactById,
    createContact,
    updateContact,
    deleteContact,
    fetchContactByClientId,
    searchContact
  };
});
